import AOS from 'aos';

AOS.init({
	once: true,
	useClassNames: true,
	initClassName: false,
	animatedClassName: 'animated',
});
